<template>
  <section>
    <v-card>
      <v-card-title class="chart-title" primary-title>
        Registrations by School Sector
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="items"
        hide-default-footer
        disable-initial-sorts
        class="dataTable"
      >
        <template v-slot:items="props">
          <td>{{ props.item.name }}</td>
          <td class="text-center">{{ props.item.month }}</td>
          <td class="text-center">{{ props.item.overall }}</td>
        </template>
      </v-data-table>
    </v-card>
  </section>
</template>

<script>
export default {
  async mounted() {
    // const items = await this.$axios.get(
    //   'api/clients/reports?type=schoolsBySector&date_start=2010-01-01&date_end=2030-01-01'
    // )
    // this.items = items
  },
  data() {
    return {
      headers: [
        {
          text: 'School Sector',
          align: 'left',
          sortable: true,
          value: 'name'
        },
        { text: 'Month', align: 'center', sortable: true, value: 'month' },
        { text: 'Overall', align: 'center', sortable: true, value: 'overall' }
      ],
      items: [
        {
          name: 'public',
          month: 'January',
          overall: '3'
        },
        {
          name: 'public',
          month: 'February',
          overall: '3'
        }
      ],
      pagination: {
        rowsPerPage: 4
      }
    }
  },
  computed: {
    pages() {
      if (
        this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      )
        return 0

      return Math.ceil(this.pagination.totalItems / this.pagination.rowsPerPage)
    }
  }
}
</script>

<style lang="scss" scoped></style>
